<template>
  <div id="paypal-button"></div>
</template>

<script>

import {loadScript} from "@paypal/paypal-js";
import {mapGetters} from "vuex";
import PaymentMixin from "@/views/Financial/mixins/PaymentMixin";

export default {
  name: "PaypalButton",
  data() {
    return {
      style: {
        shape: 'pill',
        color: 'gold',
        layout: 'horizontal',
        label: 'paypal',
        tagline: false
      }
    }
  },
  mixins: [PaymentMixin],

  mounted() {
    this.paymentGate = 'PayPal'
    loadScript({
      "client-id": this.userDetails.Office.Paypal_Client_ID,
      "currency": 'EUR'
    })
        .then((paypal) => {
          paypal
              .Buttons({
                style: {
                  color: 'blue'
                },
                createOrder: this.createOrder,
                onApprove: this.onPaypalApprove,
                onCancel: this.onCancel,
                onError: this.onError,
              })
              .render('#paypal-button');
        })
        .catch((err) => {
          console.error("failed to load the PayPal JS SDK script", err);
        })

  },
  computed: {
    ...mapGetters([
      'userDetails'
    ]),
    paypalItems() {
      return this.items.map(item => item)
    },
  },
  methods: {
    onCancel(data, action) {
      this.$emit('onCancel')
    },
    onPaypalApprove(data, actions) {
     console.log('hey')
      this.sendPayment()
          .then(resp => actions.order.capture())
          .then(
              (orderDetails) => {
                console.log(orderDetails);
                this.$emit('onApprove', orderDetails)
              })

    },
    createOrder(data, actions) {
      let totalValue = this.totalValue;
      if (totalValue <= 0) return;
      return actions.order.create({
        application_context : {
          locale:'el-GR',
          shipping_preference:"NO_SHIPPING"

        },
        purchase_units: [
          {
            amount: {
              currency_code: 'EUR',
              value: totalValue,
              breakdown: {
                item_total: {
                  value: totalValue,
                  currency_code: 'EUR',
                }
              }
            },
            items: this.paypalItems
          },
        ],

      });
    },
    onError(err) {
      this.$emit('error', err)
    }
  },

}
</script>

<style scoped>

</style>
